import Color from "../../theme/Colours";

export const titleStyle = {
  fontWeight: 600,
  fontFamily: "Montserrat",
  fontSize: "17.8px",
  color: Color.headerTextColor,
  mt: "15px",
};

export const placeholderStyle = {
  fontWeight: 500,
  fontFamily: "Montserrat",
  fontSize: "15.45px",
  color: "#84818A",
};

export const labelStyle = {
  fontWeight: 600,
  fontFamily: "Roboto",
  fontSize: "14px",
  marginBottom: "7px",
  color: Color.defaultFontColor,
};
